<template>
  <div class="container">
    <div class="share"
    　  id="copy_text"
  　　　ref="copy"
　　　　data-clipboard-action="copy"
  　　　:data-clipboard-text="code"
  　　　@click="copy"
    >分享</div> 
    <div class="content"  v-if="!isSuccess">
      <span class="logo"></span>  
      <h1>实时销量榜2.0 <i></i></h1>
      <h2>邀您内测</h2>
      <p>更优质的商品展示 / 更高效的选品效率 /更心动的推广体验</p>
      <h3 class="margin"><i>·</i>防刷系统2.0<i>·</i></h3>
      <p>加入更多维度作为参考，建立更加强大、准确、<br/>及时的防刷体系！</p>
      <h3><i>·</i>商品过滤机制<i>·</i></h3>
      <p>有效过滤非社交淘客出单，榜单结果更有针对<br/>性，价值更高！</p>
      <div @click="sigin" class="btn">立即报名</div>
      <p>仅限前500名用户，名额有限，赶快报名吧！</p>
      <login v-if="showLogin" @onSuccess='loginSuc'/>
    </div>
    <div class="success" v-if="isSuccess">
      <span class="reward"></span>  
      <h1>恭喜你<br/>报名成功</h1>
      <p>现在访问大淘客实时榜单</p>
      <p>即可查看实时销量榜2.0</p>
      <p>赶紧开启你的全新选品之旅吧</p>

    </div>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'

export default {
  name: 'Login',
  data () {
    return {
      showLogin:false,
      isSuccess:false,
      code:`大淘客的新榜单【实时热销榜2.0】快来看看哇！${window.location.href}`
    }
  },
  props:{
  },
  components:{
    login:Login
  },
  mounted(){

  },
  methods:{
    sigin(){
      this.showLogin = true
    },
    loginSuc(res){
      this.signUp()
    },
    copy() {
      var clipboard = new this.Clipboard("#copy_text");
      clipboard.on("success", (e) => {
        layer.msg('复制成功')
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        Message({
          message: "该浏览器不支持自动复制",
          type: "warning",
        });
        // 释放内存
        clipboard.destroy();
      });
    },
    signUp(){
        this.$services.getAddTop({}).then(res=>{
          if(res.code ==1 ){
            this.isSuccess = true
          }else{
            layer.msg(res.msg)
          }
        })
    }

  }
}
</script>
<style>
.share{
  width: 72px;
  height: 32px;
  border-radius:20px 0 0 20px ;
  background: rgba(0,0,0,0.4);
  color:#fff;
  font-size:16px;
  text-align:center;
  line-height:32px;
  position:absolute;
  right:0;
  top:0;
  z-index:9;
}
.content,.success{
  position:fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  background: url(../assets/bg.png) no-repeat top;
  background-size:100% auto;
  text-align:center;
  color:#fff;
  padding:0 20px;
  box-sizing:border-box;
}
h1{
  font-size:44px;
  margin:0;
  position:relative;
}
h1 i{
  width:45px;height:23px;
  position:absolute;
  right:20px;
  top:-20px;
  background: url(../assets/new.png) no-repeat center / contain;
}
h2{
  font-size:32px;
  margin:0;
  font-weight: normal;
}
h3{
  font-size:16px;
  color:#FFF10E;
  font-weight: normal;
  margin:13px 0 5px;
}
h3 i{
  font-style:normal;
  font-size:40px;
  margin:0 5px;
  line-height: 0;
  height: 0;
  position: relative;
  top: 8px;
}
p{
  font-size:12px;
  margin:4px 0;
}
.margin{
  margin-top:35px;
}
.logo{
  display:block;
  width:79px;
  height:24px;
  background: url(../assets/logo.png) no-repeat center / contain;
  margin:139px  auto 32px;
}
.btn{
  width: 320px;
  height: 44px;
  line-height:44px;
  border-radius: 22px;
  background: rgba(255,255,255,1);
  color:#FF6E41;
  font-size:20px;
  margin:38px 0 13px;
}
.success{
  background-image: url(../assets/suc_bg.png);
}
.success h1{
  margin-bottom:13px;
}
.reward{
  display:block;
  width:276px;
  height:276px;
  margin:109px auto -30px;
  background: url(../assets/reward.png) no-repeat center / contain;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue